import React, { useEffect, useState, useRef } from 'react';
import {
  CanvasControllerBar,
  CanvasControllerContainer,
  IconButtonContainer,
  Icon,
  ProgressBarContainer,
  ProgressBarFill,
  ProgressBarLeft,
  ProgressBarMarker,
} from './styles';

Math.clamp = function (value, min, max) {
  return Math.min(Math.max(value, min), max);
};

const FreecodePlayerFooter = React.forwardRef(
  (
    {
      loading,
      testImplementation,
      buttonsDisabled,
      isRunButtonActive,
      setIsRunButtonActive,
      stepForward,
      stepBackward,
      progressPercentage,
      updateProgressBarByPercentage,
    },
    ref
  ) => {
    const [isHoveringProgress, setIsHoveringProgress] = useState(false);
    const [mouseProgress, setMouseProgress] = useState(false);
    const [isAnimated, setIsAnimated] = useState(false);

    // rendered element refs
    const progressContainer = useRef(null);

    useEffect(() => {
      setIsAnimated(!loading && !buttonsDisabled && testImplementation?.configCanvas?.canvasAnimated);
    }, [loading, testImplementation, buttonsDisabled]);

    useEffect(() => {
      if (!mouseProgress) return;

      // Calculate percentage based on mouse position
      const updateProgressPercentageByMousePos = (e) => {
        if (!progressContainer?.current) return;
        let p = progressContainer.current.getBoundingClientRect();
        let percentage = Math.clamp(e.clientX - p.left, 0, p.width) / p.width;
        updateProgressBarByPercentage(percentage);
      };

      // Stop updating when when no longer holding down mouse
      const mouseUpHandler = (event) => {
        setMouseProgress(false);
        updateProgressPercentageByMousePos(event);
      };

      // Add progress bar mouse events
      document.addEventListener('mousemove', updateProgressPercentageByMousePos);
      document.addEventListener('mouseup', mouseUpHandler);
      return () => {
        // Remove progress bar mouse events
        document.removeEventListener('mousemove', updateProgressPercentageByMousePos);
        document.removeEventListener('mouseup', mouseUpHandler);
      };
    }, [mouseProgress, updateProgressBarByPercentage]);

    return (
      <CanvasControllerBar ref={ref}>
        {isAnimated && (
          <ProgressBarContainer
            ref={progressContainer}
            onMouseDown={() => setMouseProgress(true)}
            onMouseEnter={() => setIsHoveringProgress(true)}
            onMouseLeave={() => setIsHoveringProgress(false)}
          >
            <ProgressBarFill>
              <ProgressBarLeft progressPercentage={progressPercentage} />
              <ProgressBarMarker
                isHovering={isHoveringProgress || mouseProgress}
                progressPercentage={progressPercentage}
              />
            </ProgressBarFill>
          </ProgressBarContainer>
        )}
        <CanvasControllerContainer>{/* <Icon icon={'fa fa-cog'} /> */}</CanvasControllerContainer>

        {isAnimated && (
          <CanvasControllerContainer>
            <IconButtonContainer
              disabled={isRunButtonActive || loading || buttonsDisabled}
              onClick={() => stepBackward()}
            >
              <Icon icon={'fa fa-step-backward'} />
            </IconButtonContainer>
            <IconButtonContainer
              disabled={isRunButtonActive || loading || buttonsDisabled}
              onClick={() => stepForward()}
            >
              <Icon icon={'fa fa-step-forward'} />
            </IconButtonContainer>
            <IconButtonContainer
              disabled={loading || buttonsDisabled}
              onClick={() => setIsRunButtonActive(!isRunButtonActive)}
              title="Play and pause the simulation"
            >
              <Icon icon={isRunButtonActive ? 'fa fa-pause' : 'fa fa-play'} />
            </IconButtonContainer>
          </CanvasControllerContainer>
        )}
      </CanvasControllerBar>
    );
  }
);

export default FreecodePlayerFooter;
